import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useTheme } from '@ow/theme'
import StyledDrawer from './styled/drawer'
import { StyledContent, StyledFooter } from './styled/content'
import Header from './Header'
import RenderIf from '../render-if'

const Drawers = (props) => {
  const { themeClass } = useTheme()
  const {
    className,
    children,
    style,
    width,
    height,
    defaultOpen,
    open,
    placement,
    level,
    handler,
    levelMove,
    ease,
    duration,
    getContainer,
    onChange,
    showMask,
    maskClosable,
    onHandleClick,
    closeOnEscape,
    maskStyle,
    onClose,
    contentWrapperStyle,
    title,
    wrapperClassName,
    footer: Footer,
  } = props
  return (
    <StyledDrawer
      className={clsx(themeClass, className, {
        hidden: open === false,
      })}
      style={style}
      open={open}
      onClose={onClose}
      width={width}
      height={height}
      defaultOpen={defaultOpen}
      handler={handler}
      placement={placement}
      level={level}
      maskStyle={maskStyle}
      maskClosable={maskClosable}
      levelMove={levelMove}
      ease={ease}
      duration={duration}
      getContainer={getContainer}
      onChange={onChange}
      showMask={showMask}
      onHandleClick={onHandleClick}
      closeOnEscape={closeOnEscape}
      wrapperClassName={wrapperClassName}
      contentWrapperStyle={contentWrapperStyle}
    >
      <RenderIf isTrue={title}>
        <Header title={title} onClose={onClose} />
      </RenderIf>
      <StyledContent>{children}</StyledContent>
      <RenderIf isTrue={Footer}>
        <StyledFooter>
          <div className="footer-box">
            <Footer />
          </div>
        </StyledFooter>
      </RenderIf>
    </StyledDrawer>
  )
}

// 参数类型
Drawers.propTypes = {
  style: PropTypes.shape,
  className: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.string,
  handler: PropTypes.bool,
  placement: PropTypes.string,
  level: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  defaultOpen: PropTypes.bool,
  duration: PropTypes.string,
  ease: PropTypes.string,
  maskStyle: PropTypes.shape,
  contentWrapperStyle: PropTypes.shape,
  footer: PropTypes.node,
  onChange: PropTypes.func,
  showMask: PropTypes.bool,
  maskClosable: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  closeOnEscape: PropTypes.bool,
}
Drawers.defaultProps = {
  style: null,
  width: '',
  className: '',
  placement: 'left',
  defaultOpen: false,
  level: 'all',
  duration: '.3s',
  ease: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  onChange: () => {},
  handler: (
    <div className="drawer-handle">
      <i className="drawer-handle-icon" />
    </div>
  ),
  maskStyle: {},
  showMask: true,
  maskClosable: true,
  wrapperClassName: '',
  closeOnEscape: true,
  children: null,
  footer: null,
  contentWrapperStyle: null,
}
export default Drawers
